<ng-container *ngIf="viewModel$ | async as viewModel; else loading">
  <ng-container *ngIf="viewModel.eventOfferTypes.length > 0">
    <div class="list-header" fxLayout="row" fxLayoutAlign="space-between center">
      <mat-checkbox (change)="toggleSelectAll($event.checked)" [checked]="isAllSelected()"
        [indeterminate]="isSomeSelectedOnPage() && !isAllSelected()">Select All</mat-checkbox>

      <a class="view-selected-link" *ngIf="canEdit() && selectedCount > 0" appAuthorizeControl="edit||offermang" href="#"
        matTooltip="Selected Records" (click)="onViewSelected($event)">
        View selected ({{ selectedCount }})
      </a>
    </div>
     
    <div class="grid">
      <ng-container *ngFor="let row of displayRows; trackBy: trackDisplayRow">

        <!-- Skeleton while GetPreview loads for this variant -->
        <mat-card *ngIf="row.kind === 'skeleton'" appearance="outlined" class="variant-skeleton-card">
          <mat-card-content fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="8px">
            <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
            <span class="variant-skeleton-label">Loading variant…</span>
          </mat-card-content>
        </mat-card>

        <!-- Base or hydrated variant card -->
        <mat-card *ngIf="row.kind === 'base' || row.kind === 'variant'" appearance="outlined"
          [ngClass]="{
            'card--variant-row': row.kind === 'variant',
            'card--modified': isModifiedOffer(row.offer)
          }">
          <span class="modified-badge" *ngIf="isModifiedOffer(row.offer)">MODIFIED</span>
          <mat-card-content>

            <span class="rank" *ngIf="row.offer?.Detail?.Rank">Rank : {{ row.offer?.Detail?.Rank }}</span>

            <div class="offer-status">
              <span [matMenuTriggerFor]="canEdit() ? menu : null" class="ellipsis-3-line {{ getStatusClass(row.offer) }}">
                {{ getStatusText(row.offer) }}
                <mat-icon *ngIf="canEdit()" class="icon">arrow_drop_down</mat-icon>
              </span>
            </div>

            <mat-menu #menu="matMenu" class="status-menu">
              <button type="button" mat-menu-item class="statusAPPROVED"
                [disabled]="row.offer?.Detail?.Status === 'APPROVED'" (click)="updateStatus(Status.APPROVED, row.offer)">
                APPROVED
              </button>
              <button type="button" mat-menu-item class="statusPENDING"
                [disabled]="row.offer?.Detail?.Status === 'PENDING'" (click)="updateStatus(Status.PENDING, row.offer)">
                PENDING
              </button>
              <button type="button" mat-menu-item class="statusSUPPRESSED"
                [disabled]="row.offer?.Detail?.Status === 'SUPPRESSED'" (click)="updateStatus(Status.SUPPRESSED, row.offer)">
                SUPPRESSED
              </button>
            </mat-menu>

            <div class="grid-col-span-2 offer-name" title="{{ row.offer?.Detail?.Name }}" fxLayout="row wrap"
              fxLayoutAlign="start start" fxLayoutGap="15px">
              <mat-checkbox *ngIf="row.kind === 'base'" (click)="$event.stopPropagation()" fxFlex="30px" class="card-checkbox"
                (change)="toggleSelect($event.checked, row.offer)" [checked]="selection.isSelected(row.offer)">
              </mat-checkbox>
            </div>

            <div fxLayoutAlign="center center" class="offer-image">
              <img mat-card-md-image
                [src]="row.offer.FacingAsset ? (row.offer.FacingAsset | offerPreview: PreviewMode.Medium) : './assets/images/default-image.png'"
                alt="Offer image" (error)="onImageError($event)">
            </div>

            <div class="offer-content" fxLayout="column">
                <div *ngIf=" variantViewMode === 'expanded' && row.offer?.Variants?.length && row.offer.Variants.length > 1">
                  <mat-form-field class="versions" appearance="outline">
                    <mat-select [(value)]="row.offer.Detail.Id" placeholder="Select Variant"
                      (selectionChange)="onVariantChange($event.value, row.offer)">
                      <mat-option *ngFor="let variant of row.offer?.Variants" [value]="variant?.Id">
                        {{variant?.OfferVariantName}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              
                <div *ngIf="variantViewMode === 'compressed' && row.offer?.Variants?.length && row.offer.Variants.length > 1"
                  class="offer-bodycopy">
                  <mat-form-field class="versions" appearance="outline">
                    <mat-select [(value)]="row.offer.Detail.Id" placeholder="Select Variant"
                      (selectionChange)="onVariantChange($event.value, row.offer)">
                      <mat-option *ngFor="let variant of row.offer?.Variants" [value]="variant?.Id">
                        {{variant?.OfferVariantName}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

              <div class="offer-headline">
                <span [innerHtml]="row.offer?.PricingPreviewHtml"></span>
              </div>
            </div>

            <div class="card-footer grid-col-span-2" fxLayout="row wrap" fxLayoutGap="15px">
              <div class="card_footer_row">
                <div class="card_footer_col-1">
                  <span title="{{ row.offer?.OfferTagNames }}" class="card-footer-text w-100">
                    Tags : {{ row.offer?.OfferTagNames }}</span>
                  <span *ngIf="row.offer?.VersionNames; else noVersionAssigned"
                    title="{{ row.offer?.VersionNames }}" class="card-footer-text version-codes w-100">
                    Versions : {{ row.offer?.VersionNames }}</span>
                  <ng-template #noVersionAssigned>
                    <span class="card-footer-text version-codes version-codes--missing w-100"
                      role="status" aria-label="No version assigned"
                      title="No version assigned">
                      <mat-icon class="version-warning-icon" aria-hidden="true">warning</mat-icon>
                      <span class="version-warning-text">No version assigned</span>
                    </span>
                  </ng-template>
                </div>
                <div class="card_footer_col-center">
                  <div *ngIf="row.offer?.Badge" class="badge-container">
                    <img mat-card-md-image
                      [src]="row.offer.Badge ? (row.offer.Badge | offerPreview: PreviewMode.Medium) : './assets/images/default-image.png'"
                      alt="Badge image" (error)="onImageError($event)">
                  </div>
                </div>
                <div class="card_footer_col-2">
                  <div class="page-position">
                    <span title="{{ row.offer?.PageNumber }}" class="card-footer-text w-100">
                      Page: {{ row.offer?.PageNumber }}</span>
                    <span title="{{ row.offer?.Position }}" class="card-footer-text version-codes w-100">
                      Position: {{ row.offer?.Position }}</span>
                  </div>
                </div>
              </div>

              <div class="card-footer-text">
                <span class="footer-text">{{ row.offer?.EventOfferType == 'OFFERGROUP'? 'OFFER GROUP':
                  row.offer?.EventOfferType }}<span
                    *ngIf="row.offer?.EventOfferType == 'OFFERGROUP'">({{row.offer?.OffersCount}})</span></span>
                <span class="footer-text display">Client Key: <span
                    title="{{ row.offer?.Detail?.ClientKey }}">{{row.offer?.Detail?.ClientKey }}</span></span>
              </div>

              <div fxLayOut="row" class="card-footer-btns">
                <button
                  *ngIf="row.kind === 'base' && row.offer?.VariantsCount && row.offer.VariantsCount > 1 && row.offer?.EventOfferType === 'OFFER'"
                  mat-button type="button" color="accent" [routerLink]="[row.offer?.Detail?.Id, 'childversions']"
                  [queryParamsHandling]="'preserve'">
                  Variants({{row.offer?.VariantsCount}})</button>
                <button
                  *ngIf="row.kind === 'base' && row.offer?.VariantsCount && row.offer.VariantsCount > 1 && row.offer?.EventOfferType === 'PROMO'"
                  mat-button type="button" color="accent"
                  [routerLink]="[row.offer?.Detail?.Id, 'promo', 'childversions']" [queryParamsHandling]="'preserve'">
                  Variants({{row.offer?.VariantsCount}})</button>
                <button *ngIf="row.offer?.EventOfferType === 'OFFER'" class="offer-button" type="button" mat-button
                  color="accent" [routerLink]="[row.offer?.Detail?.Id, 'details']"
                  [queryParamsHandling]="'preserve'">
                  <span>{{canEdit()?'Edit':'View Details'}}</span>
                </button>
                <button *ngIf="row.offer?.EventOfferType === 'PROMO'" class="offer-button" type="button" mat-button
                  color="accent" [routerLink]="[row.offer?.Detail?.Id, 'promos', 'promodetails']"
                  [queryParamsHandling]="'preserve'">
                  <span>{{canEdit()?'Edit':'View Details'}}</span>
                </button>
                <button *ngIf="row.offer?.EventOfferType === 'OFFERGROUP'" class="offer-button" type="button" mat-button
                  color="accent" [routerLink]="[row.offer?.Detail?.Id, 'offergroups', 'offergrpdetails']"
                  [queryParamsHandling]="'preserve'">
                  <span>{{canEdit()?'Edit':'View Details'}}</span>
                </button>
                <div class="comments pl-18">
                  <ng-container
                    *ngIf="row.offer?.CommentsCount !== undefined && row.offer?.CommentsCount! > 0; else noComments">
                    <div id="{{row.offer?.DomainId}}" (click)="openDialog($event, row.offer)" class="comments-dialog">
                      <i class="fa fa-comment font-12" aria-hidden="true"></i>
                      <span class="comments-count">{{row.offer?.CommentsCount}}</span>
                    </div>
                  </ng-container>
                  <ng-template #noComments>
                    <span id="{{row.offer?.DomainId}}" (click)="openDialog($event, row.offer)" class="comments-dialog">
                      <i class="fa fa-comment-o font-12" aria-hidden="true"></i>
                    </span>
                  </ng-template>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </ng-container>
    </div>
  </ng-container>

  <ng-container *ngIf="viewModel?.eventOfferTypes?.length === 0">
    <table>
      <tr>
        <td class="no-records">
          <h2>No offers Found</h2>
        </td>
      </tr>
    </table>
  </ng-container>
</ng-container>

<ng-template #loading>
  <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
</ng-template>
